import { render, staticRenderFns } from "./SectionSeparator.vue?vue&type=template&id=e8b59612"
import script from "./SectionSeparator.vue?vue&type=script&lang=js"
export * from "./SectionSeparator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports